import React from 'react';

import { handleSuggestedQuestionClick } from '../../store/dashboard/askAica/globalAskAicaService';
import { AgentInput } from '../../store/dashboard/askAica/actions';

import MagicUploadSvg from '../../assets/Svg/MagicUploadSvg.svg';

import styles from './AskAicaQuestionBadge.module.scss';

type Props = {
    question: string;
    prompt?: string;
    flowKey?: string;
    agentInput?: AgentInput;
};

const AskAicaQuestionBadge: React.FC<Props> = ({ question, prompt, flowKey, agentInput }) => {
    const handleClick = () => {
        handleSuggestedQuestionClick(prompt ?? question, flowKey, agentInput);
    };
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };
    return (
        <div
            className={styles.AskAicaQuestionBadge}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label={question}
        >
            <img src={MagicUploadSvg} alt="" aria-hidden="true" />
            <div className={styles.AskAicaQuestionBadgeText} aria-hidden="true">✦ {question}</div>
        </div>
    );
};

export default AskAicaQuestionBadge;
